<template>
  <div>
    <el-input
      :placeholder="initSiteValue||'请输入目的地'"
      clearable
      ref="siteInput"
      v-model="siteValue"
      @focus="inputFocus"
      @blur="inputBlur"
      @keyup.native="keyDownFun($event)"
    ></el-input>
    <div class="up-site" @mousemove="enter" @mouseleave="leave" v-if="isSiteBox">
      <div class="head">
        <!-- <span>支持中文/拼音/字母</span> -->
        <i class="el-icon-close" @click="isVanishing = false,$refs.siteInput.blur()"></i>
      </div>
      <div v-show="siteShow" style="padding:0 10px">
        <ul class="site-nav">
          <li
            v-for="(item,index) in pinYinList"
            :key="index"
            :class="{'li-active':listActive===index}"
            @click="getActive(item,index)"
          >
            {{item}}
            <i :class="{'site-nav-ico':listActive===index}"></i>
          </li>
        </ul>
        <div class="site-list scrollbar">
          <div
            class="site-item"
            v-for="(item,index) in siteActiveList"
            :key="index"
            v-if="item.length>0"
          >
            <span>{{index}}</span>
            <ul class="site-item-name">
              <li
                v-for="(zitem,index) in item"
                :key="index"
                @mousedown="stopNative($event)"
                @click.stop="getSiteItem(zitem)"
              >{{zitem.cityCn}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div v-show="!siteShow" class="search-site-list scrollbar">
        <p class="warning" v-show="warningShow">对不起，找不到：{{siteValue}}</p>
        <div
          v-for="(item,index) in searchSite"
          :key="index"
          @mousedown="stopNative($event)"
          @click.stop="getSiteItem(item),siteShow = true"
        >
          <div
            class="flex-center-end cursor search-site-item"
            :class="{'Search-item-shwo':itemShow==index}"
            @mouseenter="itemShow = index"
          >
            <p>{{item.cityCn}} ({{item.cityPinyin}})</p>
            <p>城市</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pinYinList: ["ABCD", "EFGH", "JKLM", "NOPQRS", "TUVWX", "YZ"],
      listActive: 0,
      siteObj: {},
      siteActiveList: {}, //选中的城市列表
      siteShow: true, //搜索地址显示
      isSiteBox: false,
      searchSite: [], //搜索后地址
      itemShow: 0,
      warningShow: false,
      siteValue: "",
      isClickItem: false
    };
  },
  created() {
    this.getList(this.siteList);
    this.getActive("ABCD", 0);
  },

  props: ["siteList", "initSiteValue"],
  watch: {
    //搜索查询地址
    siteValue(val) {
      if (!val) {
        this.siteShow = true;
        this.$emit("getItem", "");
        this.$refs.siteInput.focus();
        return;
      }
      this.siteShow = false;
      let list = this.siteList;
      this.selectAsync(this.selectGet(list, val), 500);
      this.itemShow = 0;
      // this.$emit("inputItem", this.searchSite[0]);
    },
    // initSiteValue(val) {
    //   console.log("123123", val);
    //   this.siteValue = val;
    // },
    async siteList(val) {
      this.getList(val);
      this.getActive("ABCD", 0);
    }
  },
  methods: {
    stopNative(e) {
      e.preventDefault();
    },
    keyDownFun(e, val) {
      if (this.searchSite.length === 0) return;
      let offset = document.getElementsByClassName("search-site-list")[1];
      e = window.event || e;
      switch (e.keyCode) {
        case 38: //向上键
          if (this.itemShow === 0) return;
          offset.scrollTop -= 30;
          this.itemShow--;
          break;
        case 40: //向下键
          if (this.searchSite.length - 1 === this.itemShow) return;
          this.itemShow++;
          offset.scrollTop += 30;
          break;
        case 13:
          this.getSiteItem(this.searchSite[this.itemShow]);
          break;
        default:
          break;
      }
    },
    enter() {
      this.isVanishing = true;
    },
    leave() {
      this.isVanishing = false;
    },
    //点击切换
    getActive(item, index) {
      this.listActive = index;
      let arr = item.split("");
      let newSite = {};
      arr.map(item => {
        for (let site in this.siteObj) {
          if (item == site) {
            newSite[item] = this.siteObj[site];
          }
        }
      });
      this.siteActiveList = newSite;
    },
    //生成城市列表
    getList(val) {
      let list = val;
      let siteArr = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ];
      let siteObj = {};
      //排列城市列表
      siteArr.map(letter => {
        siteObj[letter] = list.filter(item => {
          return letter === item.cityPinyinSimp.charAt(0);
        });
      });
      this.siteObj = siteObj;
    },
    //查询搜索
    selectGet(list, val) {
      let arr = [];
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(val)) {
        arr = list.filter(item => {
          return item.cityCn.indexOf(val) > -1;
        });
      } else {
        val = val.toLowerCase();
        arr = list.filter(item => {
          if (item.cityPinyinSimp.toLowerCase().indexOf(val) > -1) {
            return item;
          } else {
            return item.cityPinyin.toLowerCase().indexOf(val) > -1;
          }
        });
      }
      arr.length == 0 ? (this.warningShow = true) : (this.warningShow = false);
      this.searchSite = arr;
    },
    inputFocus() {
      this.isSiteBox = true;
      this.siteShow = true;
    },
    inputBlur() {
      var isShow = () => {
        if (!this.isVanishing) {
          this.isSiteBox = false;
        } else {
          //选中点击
          this.$refs.siteInput.focus();
        }
      };
      isShow();
      // if (this.searchSite.length > 0 && this.siteValue.indexOf(")") === -1) {
      //   this.getSiteItem(this.searchSite[0]);
      // }
    },
    //查询地址
    selectAsync(fn, delay) {
      let handle;
      return function(e) {
        // 取消之前的延时调用
        clearTimeout(handle);
        handle = setTimeout(() => {
          fn(e);
        }, delay);
      };
    },
    //点击城市
    getSiteItem(item) {
      this.isVanishing = false;
      this.siteValue = item.cityCn;
      this.$refs.siteInput.blur();
      this.$emit("getItem", item);
      // this.upBoxEndSite();
    }
  }
};
</script>
<style lang="less" scoped>
.up-site {
  width: 400px;
  min-height: 300px;
  background: white;
  border: 1px solid #ccc;
  position: absolute;
  top: 40px;
  z-index: 9999;
  line-height: 30px;
  font-size: 13px;
  padding: 5px;
  .warning {
    font-size: 13px;
    color: #e96752;
  }
  .search-site-list {
    min-height: 200px;
    max-height: 300px;
    overflow-y: auto;
    .search-site-item {
      padding: 0 15px;
    }
    .Search-item-shwo {
      background: #2577e3;
      color: white;
    }
  }
  .head {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: rgb(153, 153, 153);
    padding: 5px 8px;
    // border-bottom: 1px #dfdfdf dashed;
    .el-icon-close {
      cursor: pointer;
      font-size: 15px;
      &:hover {
        color: #ffa800;
      }
    }
  }
  .site-nav {
    display: flex;
    justify-content: space-around;
    border-bottom: 2px solid #ccc;
    li {
      list-style: none;
      padding: 0 5px;
      cursor: pointer;
    }
    .site-nav-ico {
      display: block;
      height: 2px;
      width: 100%;
      background: #2577e3;
      padding: 0 5px;
      transform: translate(-5px, 2px);
    }
    .li-active {
      color: #2577e3;
    }
  }
  .site-list {
    margin: 10px 0;
    min-height: 200px;
    max-height: 300px;
    overflow-y: auto;
    .site-item {
      display: flex;
      span {
        color: #e96752;
      }
      .site-item-name {
        margin-left: 10px;
        li {
          list-style: none;
          float: left;
          padding: 0 5px;
          min-width: 80px;
          cursor: pointer;
          &:hover {
            background: #2577e3;
            color: white;
          }
        }
      }
    }
  }
}
// /deep/.el-input {
//   ::-webkit-input-placeholder {
//     color: black;
//     font-size: 12px;
//   }
// }
</style>
<style>
/* IE 浏览器 */
.scrollbar {
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #fff;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #0099dd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #0099dd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #0066ff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}

/* chrome & safari 浏览器 */
/*滚动条整体部分,必须要设置*/
.scrollbar::-webkit-scrollbar {
  width: 3px;
  height: 2px;
  background-color: #0099ff;
}
/*滚动条的轨道*/
.scrollbar::-webkit-scrollbar-track {
  background-color: #ccc;
}
/*滚动条的滑块按钮*/
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: #0099ff;
  box-shadow: inset 0 0 5px #0099ff;
}
/*滚动条的上下两端的按钮*/
.scrollbar::-webkit-scrollbar-button {
  height: 0;
  background-color: #ccc;
}
</style>
